// global
import { createStore, applyMiddleware } from 'redux';
// middlewares
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
// local
import reducers from './reducers';

// Create a history of your choosing (we're using a browser history in this case)
// mount the middlewares
const history = require('history').createBrowserHistory();
const middlewares = [];
middlewares.push(thunk);
middlewares.push(routerMiddleware(history));

// only add the log if running on development
if (process.env.REACT_APP_ENVIRONMENT === 'development') {
    middlewares.push(createLogger({ collapsed: true, duration: true, diff: true }));
}
// Add the reducer to your store on the `router` key
// Also apply our middleware for navigating
const store = createStore(reducers, applyMiddleware(...middlewares));
// Create an enhanced history that syncs navigation events with the store
export { store, history };